import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import uuid from "uuid";
import linkState from 'linkstate';
import './admin-gallery.css';
import LinearProgress from '@material-ui/core/LinearProgress';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { Box } from '@material-ui/core';

class AdminGalleryDialog extends Component {

  constructor(props) {
    super(props);

    this.isAddMode = true;

    this.state = {
      gallery: {
        unikey: '',
        title: '',
        description: '',
      },
      loading: true,
      snackBar: false,
    };

    if(Object.keys(props.galleryData).length >= 1)
    {
      this.isAddMode = false;
      
      this.state.gallery = {
        ...props.galleryData,
      };
      this.state.loading = false;
    }
    else
    {
      this.state.gallery.unikey = uuid.v4();
      this.state.loading = false;
    }
  }

  submitDialog()
  {
    var galleryData = { ...this.state.gallery };

    if( galleryData.title === '')
    {
      this.setState({ snackBar: true, });
    }
    else
    {
      this.props.submit(this.isAddMode, galleryData);
    }
  }

  closeSnackBar (event, reason)
  {
    if (reason === 'clickaway') {
      return;
    }

    this.setState({ snackBar: false, });
  }


  render() {
    return (
      <div>
        <DialogTitle id="form-dialog-title">Galerie { this.isAddMode ? "Erstellen" : "Bearbeiten" }</DialogTitle>
        { this.state.loading ? <LinearProgress color="primary" /> : <span className="loader-span"></span> }
        <DialogContent>
          <Box style={{ marginBottom: '20px' }}>
            <TextField
              autoFocus
              margin="dense"
              id="title"
              label="Titel"
              type="text"
              fullWidth
              variant="outlined"
              value={this.state.gallery.title || ''}
              onInput={linkState(this, 'gallery.title')}
            />
          </Box>
          <Box style={{ marginBottom: '20px' }}>
            <TextField
              margin="dense"
              id="description"
              multiline
              rows={4}
              label="Beschreibung"
              type="text"
              fullWidth
              variant="outlined"
              value={this.state.gallery.description || ''}
              onInput={linkState(this, 'gallery.description')}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <div className="p-line-end">
            <Button variant="contained" onClick={this.props.close}>
              Abbrechen
            </Button>
            <span></span>
            <Button variant="contained" color="primary" onClick={() => { this.submitDialog() }}>
              Speichern
            </Button>
          </div>
        </DialogActions>
        <Snackbar open={this.state.snackBar} autoHideDuration={6000} onClose={this.closeSnackBar.bind(this)}>
            <MuiAlert elevation={6} variant="filled" onClose={this.closeSnackBar.bind(this)} severity="warning" >
              Titel muss ausgefüllt sein!
            </MuiAlert>
          </Snackbar>
      </div>
    );
  }
}

export default AdminGalleryDialog;
